import {
  channelRenderHelper,
  commonRenderHelperMap,
  languageRenderHelper,
} from '../renderHelper';
import { DownloadConfigInfoType } from '../types';

export const RealtimeChannelLanguagePerformanceDownload: DownloadConfigInfoType =
  {
    columns: ({ auxiliaryParams }) => {
      const { metrics, title, type } = auxiliaryParams;
      const isLanguage = type === 'language';
      const tableColumns: any = [
        {
          key: 'time',
          header: 'Date',
        },
        {
          key: 'name',
          header: isLanguage ? 'Language' : 'Channel',
          renderHelper: isLanguage
            ? [languageRenderHelper]
            : [channelRenderHelper],
        },
        {
          key: metrics,
          header: title,
          ...(commonRenderHelperMap[metrics] || {}),
        },
      ];

      return tableColumns;
    },
  };

export const RealtimeOverviewMetricsDownload: DownloadConfigInfoType = {
  columns: ({ auxiliaryParams }) => {
    const { columns } = auxiliaryParams;
    const tableColumns = [
      {
        key: 'time',
        header: 'Date',
      },
    ];
    const restColumns = columns.map((val) => ({
      key: val.value,
      header: val.name,
      ...(commonRenderHelperMap[val.value] || {}),
    }));

    return [...tableColumns, ...restColumns];
  },
};
